import React from "react"
import { FormControl, OverlayTrigger } from "react-bootstrap"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./TextField.css"
import "../../DynamicForm.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function TextField(props: Props) {

    // console.log("df_FieldTextField props", props)

    const field = props.field
    const value = !props.formManagerField ? field.Value : null
    const name = field.Name || "Text"
    const formatter = field.Formatter ? field.Formatter.formatter : null
    const validator = field.Validator ? field.Validator.validator : null
    const valid = validator ? validator(value) : true
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"

    return (
        <div className={`DynamicForm${fieldType} DynamicText${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                    {(field.Required && !value && !validator) && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                    {(validator && !valid) && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody">
                <FormControl onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])}
                    //@ts-ignore
                    onChange={(e) => {
                        const val = e.target.value
                        const formatted = formatter ? formatter(val) : null
                        const input = formatted ? formatted : val
                        props.handleChange({ target: { value: input } })
                    }}
                    value={value || ""}
                    type="text"
                    disabled={formManagerField}
                    style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`, color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}` }}
                />
            </div>
        </div>
    )
}

export default TextField